
<po-page-list #poPageListComponent
  p-title="Relatório de Baldeio"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-sm-2 po-md-2 po-lg-2" p-label="Excel"  (p-click)="gerarExcel()"></po-button>
    <po-button class="po-sm-2 po-md-2 po-lg-2" p-label="PDF"    (p-click)="bttnPDF()"></po-button>
    <div class="po-offset-sm-10 po-offset-md-10 po-offset-lg-10 po-offset-xl-10 po-md-2">
      <po-input class="po-sm-12 po-md-12 po-lg-12"
        p-upper-case="true"
        name="inputPesquisar"
        p-icon="po-icon-search"
        p-placeholder="Pesquisar"
        [(ngModel)]="inputPesquisar"
        (p-change-model)="changeFiltro($event)">
      </po-input>
    </div>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    p-hide-table-search="true"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>
    <po-datepicker
      class="po-md-3"
      name="DZ00DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>
    <po-combo
      class="po-md-6"
      name="CZ00ORIGEM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00ORIGEM"
      p-label="Origem"
      [p-options]="varOrigem"
    ></po-combo>
    <po-combo
      class="po-md-6"
      name="CZ00STATUSBA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00STATUSBA"
      p-label="Status Baldeio"
      [p-options]="varStatusBA"
    ></po-combo>
    <po-combo
      class="po-md-6"
      name="CZ00STATUSCL"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00STATUSCL"
      p-label="Status Cliente"
      [p-options]="varStatusCL"
    ></po-combo>
  </form>
</po-modal>
